import { render } from "./BlogBirthdayGiftIdeasView.vue?vue&type=template&id=d61d611a"
import script from "./BlogBirthdayGiftIdeasView.vue?vue&type=script&lang=js"
export * from "./BlogBirthdayGiftIdeasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__